export class EmailSettings {
    status: boolean = true;
}